import RollingTomato from "../RollingTomato/RollingTomato"

import "./SpaceLoadingCard.scss"

const SpaceLoadingCard = () => {
  return (
    <div className="SpaceLoadingCard">
      <RollingTomato />
    </div>
  )
}

export default SpaceLoadingCard
